import PropTypes from "prop-types";
import { useState } from "react";
import Title from "components/shared/stays/Title";
import Text from "components/shared/stays/Text";
import Button from "solar/components/Button";
import Modal from "components/shared/stays/Modal";
import ModalBody from "components/shared/stays/ModalBody";
import Markdown from "solar/components/Markdown";
import Anchor from "solar/components/Anchor";
import SectionRhythm from "components/shared/stays/SectionRhythm";
import SurfSeason from "components/shared/stays/SurfSeason";
import SurfSeasonLegend from "components/shared/stays/SurfSeasonLegend";
import styles from "components/shared/stays/SurfConditions.module.scss";

export default function SurfConditions({
  conditions = null,
  season = [],
  oneLetter,
}) {
  const [showModal, setShowModal] = useState(false);
  const handleModalShow = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);

  return (
    <>
      <div className={styles.component}>
        <Anchor id="surf" offset />
        <div className={styles.header}>
          <Title>The surf</Title>
          <SurfSeasonLegend />
        </div>
        <SectionRhythm>
          {season && <SurfSeason season={season} oneLetter={oneLetter} />}
        </SectionRhythm>
        {conditions && (
          <>
            <SectionRhythm>
              <Text>
                <Markdown truncate>{conditions}</Markdown>
              </Text>
            </SectionRhythm>
            <SectionRhythm>
              <Button onClick={handleModalShow} ghost responsive>
                More about the surf conditions
              </Button>
            </SectionRhythm>
          </>
        )}
      </div>
      <Modal show={showModal} handleClose={handleModalClose}>
        <ModalBody>
          <div className={styles.header}>
            <Title>More about the surf</Title>
            <SurfSeasonLegend />
          </div>
          <div className={styles.content}>
            {season && <SurfSeason season={season} />}
            {conditions && (
              <SectionRhythm>
                <Markdown>{conditions}</Markdown>
              </SectionRhythm>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

SurfConditions.propTypes = {
  conditions: PropTypes.string,
  season: PropTypes.arrayOf(PropTypes.string),
  oneLetter: PropTypes.bool,
};
